/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect } from 'react';

const Effect = ({ submitForm, values, debounceFunc }) => {
  const {
    companyName,
    isFavouriteContractor,
    companyType,
    workCategories,
    services,
    states,
    zip,
    companyUser,
    grades,
    aemin,
    aemax,
    lcmin,
    lcmax,
    bcmin,
    bcmax,
    pqfStatuses,
    withOverdue,
  } = values;
  useEffect(() => {
    submitForm();
    return () => debounceFunc.cancel();
  }, [
    companyName,
    isFavouriteContractor,
    companyType,
    workCategories,
    services,
    states,
    zip,
    companyUser,
    grades,
    aemin,
    aemax,
    lcmin,
    lcmax,
    bcmin,
    bcmax,
    submitForm,
    pqfStatuses,
    withOverdue,
  ]);

  return '';
};

export default Effect;
